import {getGuideActivitySlug} from "@khan/guide-core-helpers";
import {AIActivity} from "@khan/guide-types";

/**
 * Returns true if text-to-speech should be disabled for the given path.
 */
export const isTextToSpeechDisabledForPath = (pathname: string): boolean => {
    // We currently only disable text-to-speech for the chat with historical
    // figure activity.
    return (
        AIActivity.ChatWithHistoricalFigure === getGuideActivitySlug(pathname)
    );
};
